import React, { Component } from 'react'
import { Button, Form, FormControl, Row, FormGroup, FormLabel } from 'react-bootstrap'
import TransactionDetails from './TransactionDetails'
import Axios from 'axios'

// Two step process #1 Get Token  #2 Submit Refund
class InAppPayment extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  handleSubmit = async () => {
  }

  handleNextStep = async () => {
  }


  render() {
    const { selectedItem } = this.props.tx
    return (
      <Form style={{margin:"0 2%"}}>
        <br/>
        <h5>Coming Soon...</h5>
        <h4>Transaction Details</h4>
        <div>
          <TransactionDetails selectedItem={selectedItem}/>
          &nbsp;
        </div>
      </Form>
    )
  }
}

export default InAppPayment